import { IViewModel, ViewModelAction, ViewModelStatus } from '@/lib/viewModels'
import { AuthStoreType } from '@/lib/auth/AuthStore'
import { useLocalObservable } from 'mobx-react-lite'
import { IRestfulApiService } from '@/lib/apiService'
import { useRouter } from 'next/router'
import { FormikApiStatus, FormikFormStatus } from '@/components/Formik'
import {
	ProtectionReportFormDataProps,
	ProtectionReportFormSubmit,
} from '@/modules/landings/protection/ProtectionReportForm'
import { useMemo } from 'react'
import { CreateCopyrightByUserCommand } from '@/modules/landings/protection/commands/createCopyrightByUserCommand'
import { FormikHelpers } from 'formik'
import { Modal } from 'antd'
import { publisherListFactory } from '@/modules/landings/protection/factory/publisherListFactory'
import { LOGIN_PAGE } from '@/settings/constant'

type ProtectDescriptionViewModelProps = {
	authStore?: AuthStoreType
	apiService: IRestfulApiService
	router?: ReturnType<typeof useRouter>
}

type ProtectDescriptionViewModelStatus = ViewModelStatus &
	FormikFormStatus<ProtectionReportFormDataProps, FormikApiStatus> & {
		modalOpen: boolean
		_publisherOptions: { label: string; value: string }[]
		imageFileList: File[]
		pdfFileList: File[]
	}

type ProtectDescriptionViewModelActions = ViewModelAction & {
	onSubmit: ProtectionReportFormSubmit
	get publisherOptions(): { label: string; value: string }[]
	onSetImageFile: (file: File[]) => void
	onSetPdfFile: (file: File[]) => void
}

type ProtectDescriptionViewModelLocalStore = {}

type IProtectDescriptionViewModel = IViewModel<
	ProtectDescriptionViewModelProps,
	ProtectDescriptionViewModelStatus,
	ProtectDescriptionViewModelActions
>
const loginModal = () => {
	const modal = Modal.success({
		title: '완료',
		content: '신고가 완료되었습니다.',
		okButtonProps: { style: { display: 'none' } },
	})
	setTimeout(() => {
		modal.destroy()
	}, 1500)
}
export const ProtectDescriptionViewModel: IProtectDescriptionViewModel = ({
	authStore,
	apiService,
}) => {
	const submitCopyrightInquiryCommand = useMemo(
		() => new CreateCopyrightByUserCommand(apiService),
		[apiService],
	)
	const status = useLocalObservable<ProtectDescriptionViewModelStatus>(() => ({
		errors: [],
		initialized: false,
		initialStatus: {
			apiErrors: {},
		},
		loading: false,
		modalOpen: false,
		_publisherOptions: [],
		imageFileList: [],
		pdfFileList: [],
		initialValues: {
			type: 'normal',
			title: '',
			channel: null,
			fileData: [],
			profit: '영리',
			fileImage: [],
			link: '',
			name: '',
			publisher: '',
			is_know_date: false,
			content: '',
			status: '신고됨',
			start_date: null,
		},
	}))

	const actions = useLocalObservable<
		ProtectDescriptionViewModelActions & ProtectDescriptionViewModelLocalStore
	>(() => ({
		onSetPdfFile(file) {
			console.log(file)
			status.pdfFileList = [...status.pdfFileList, ...file]
		},
		onSetImageFile(file) {
			console.log('파일', file)
			status.imageFileList = [...status.imageFileList, ...file]
		},
		async onSubmit(
			values: ProtectionReportFormDataProps,
			formikActions: FormikHelpers<ProtectionReportFormDataProps>,
		) {
			//@todo date value
			formikActions.setSubmitting(true)
			try {
				const response = await submitCopyrightInquiryCommand.execute(values)
				console.log('onSubmit', values)
				console.log('onresoibse', response)
				if (response.success) {
					status.modalOpen = false
					loginModal()
					formikActions.resetForm()
				} else {
					Modal.error({
						title: '',
						content: '오류가 발생한 것 같습니다. 새로고침 후 다시 시도해주세요.',
					})
				}
			} catch (error) {
				Modal.error({
					title: error.message,
					content: '오류가 발생한 것 같습니다. 새로고침 후 다시 시도해주세요.',
				})
			} finally {
				//팝업창
				// protectReportCompleted()
				// formikActions.setSubmitting(false)
			}
		},
		get publisherOptions() {
			//todo 추후 커맨드 생성될 예정
			status._publisherOptions = publisherListFactory()
			return status._publisherOptions
		},
		dispose(): void {},
		// handleUpload = () => {
		//     const formData = new FormData();
		//     fileList.forEach((file) => {
		//         formData.append('files[]', file as RcFile);
		//     });
		//     setUploading(true);
		//     // You can use any AJAX library you like
		//     fetch('https://www.mocky.io/v2/5cc8019d300000980a055e76', {
		//         method: 'POST',
		//         body: formData,
		//     })
		//         .then((res) => res.json())
		//         .then(() => {
		//             setFileList([]);
		//             message.success('upload successfully.');
		//         })
		//         .catch(() => {
		//             message.error('upload failed.');
		//         })
		//         .finally(() => {
		//             setUploading(false);
		//         });
		// };
	}))

	return { status, actions }
}
